<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="2" :offset="22">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="con">
			<div class="L">
				<div class="label">洗美卡类型</div>
				<el-radio-group v-model="typeId" @change="changeTypeId" style="width:210px;margin-bottom:20px;padding-top:5px;">
					<el-radio style="margin-right: 25px;" :label="1">洗澡</el-radio>
					<el-radio style="margin-right: 25px;" :label="2">美容</el-radio>
					<el-radio style="margin-right: 0px;" :label="3">SPA</el-radio>
				</el-radio-group>
				<div class="label">种类</div>
				<el-radio-group v-model="classType" @change="changeClassType" style="width:210px;margin-bottom:20px;padding-top:5px;">
					<el-radio style="margin-right: 25px;" :label="2">犬</el-radio>
					<el-radio style="margin-right: 25px;" :label="1">猫</el-radio>
				</el-radio-group>
				<div class="label">销售人员</div>
				<el-select v-model="saleManIdList" @change="changeSaleManIdList" multiple filterable placeholder="请选择"
				:disabled="['62f62cb3fc7e0b47f73e28ad','62f62d40fc7e0b47f73e2949'].indexOf(addParams.serviceId)>-1"
				size="mini" style="width:210px;margin-bottom:20px;">
					<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
					:value="item._id+','+item.basic_info.nick_name"></el-option>
				</el-select>
				<div class="label">洗美卡类型</div>
				<div class="xmjBox">
					<div class="xmjItem" :class="[virtualId===item.virtualId?'active':'']" v-for="(item,index) in serviceList" :key="index" @click="changevirtualId(item)">
						{{item.title}}
						<!-- <img class="checked"
						v-if="virtualId===item.virtualId"
						src="../../../../assets/img/bottomRightChecked.png"
						>
						<img class="checked"
						v-else
						src="../../../../assets/img/bottomRightNoChecked.png"
						> -->
					</div>
				</div>
			</div>
			<div class="R">
				<div>
					<el-row>
						<el-col :span="7" class="col">
							<div class="RLabel" style="width:65px;">体重：</div>
							<el-input v-model="weightRange" size="mini" style="width:150px">
								<template slot="append">kg</template>
							</el-input>
						</el-col>
						<el-col :span="8" class="col">
							<div class="RLabel" style="width:60px;">活动：</div>
							<el-select
							v-model="activityId"
							:disabled="$public.isNull(goodsId)||!$public.isNull(curDiscountCard)"
							@change="changeActivityId"
							placeholder="请选择"
							size="mini"
							style="width:180px;"
							clearable>
								<el-option
								v-for="item in activityList"
								:key="item._id"
								:label="item.name"
								:value="item._id"
								:disabled="!$public.calcActivity(item,addParams.goodsItem.price,1).state"
								></el-option>
							</el-select>
							<div
							v-if="giftTableData.length>0"
							@click="openGift"
							style="font-size: 12px;margin-left:5px;color:#1890FF">
								查看赠品
							</div>
						</el-col>
					</el-row>
					<div v-if="serviceList.length>0">
						<div v-for="(item,index) in serviceList" :key="index">
							<div v-if="virtualId===item.virtualId||!virtualId" style="font-size: 16px;font-weight: bold;padding:10px 20px 0;">{{item.title}}</div>
							<div v-if="virtualId===item.virtualId||!virtualId" class="roomBox">
								<div class="room" :class="[goodsId===itemServiceItem.detail_id?'active':'']" v-for="(itemServiceItem,indexServiceItem) in item.service_details" :key="indexServiceItem" @click="changeService(item,itemServiceItem)">
									<div class="mask" v-if="!isCanUse(itemServiceItem)"></div>
									<div class="tip" v-if="isWeight(itemServiceItem)">推荐</div>
									<!-- <img class="checked"
									v-if="goodsId===itemServiceItem.detail_id"
									src="../../../../assets/img/bottomRightChecked.png"
									>
									<img class="checked"
									v-else
									src="../../../../assets/img/bottomRightNoChecked.png"
									> -->
									<div class="roomName">
										<!-- <div>{{itemServiceItem.service_name}}</div> -->
										<div>{{itemServiceItem.service_objectName}}</div>
									</div>
									<div class="roomPrice">￥{{itemServiceItem.total_price}}/{{item.total_count}}次</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else style="text-align: center;">
						<img src="../../../../assets/img/rebackCarding.png" style="width:300px;margin-top:150px;"/>
						<div style="font-size: 16px;color:#999;margin:20px;">购买洗美卡</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 赠品 -->
		<div v-if="drawerGift_state">
			<setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
		</div>
	</div>
</template>
<script>
	import setGift from "../../../../components/drawer/setGift.vue"
	export default {
		components:{setGift},
		data(){
			return{
				// 赠品
				drawerGift_state:false,
				giveGoods:{},
				giftTableData:[],
				// 类型
				typeId:1,
				// 猫 狗
				classType:2,
				// 销售人员
				saleManIdList:[],
				staffList:[],
				// 洗美卡类型
				virtualId:'',
				// 体重范围
				weightRange:'',
				// 洗美服务
				goodsId:'',
				serviceList:[],
				// 活动
				activityId:'',
				activityList:[],
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			addParams(){
				return this.$store.state.xizaoka.addParams;
			},
			money(){
				return this.$store.state.xizaoka.money;
			},
			curDiscountCard(){
				return this.$store.state.xizaoka.curDiscountCard;
			},
		},
		mounted(){
			this.getStaffList();
			this.getServiceList()
		},
		methods: {
			// 返回
			back(){
				this.$store.commit('xizaoka/set_type','list')
				this.changeService();
			},
			// 赠品
			openGift(){
				this.giveGoods.giftTableData = JSON.parse(JSON.stringify(this.giftTableData))
				this.drawerGift_state=true
			},
			submit_drawerGift({giftTableData}){
				this.giftTableData = giftTableData
				this.drawerGift_state = false;
				this.addParams.giftTableData = this.giftTableData
				this.$store.commit('xizaoka/set_addParams',this.addParams)
			},
			// 修改类型
			changeTypeId(){
				this.addParams.typeId = this.typeId
				this.$store.commit('xizaoka/set_addParams',this.addParams)
				this.getServiceList()
			},
			// 修改狗猫
			changeClassType(){
				this.addParams.classType = this.classType
				this.$store.commit('xizaoka/set_addParams',this.addParams)
				this.getServiceList()
			},
			// 选择洗美卡类型
			changevirtualId(item){
				if(this.virtualId === item.virtualId){
					this.virtualId = ''
				}else{
					this.virtualId = item.virtualId
				}
				this.addParams.virtualId = this.virtualId
				this.addParams.virtualItem = item
				this.$store.commit('xizaoka/set_addParams',this.addParams)
				this.changeService();
			},
			// 服务项目
			changeService(serviceItem,goodsItem={}){
				if(!this.isCanUse(goodsItem)) return ;
				if(goodsItem.detail_id){
					this.goodsId = goodsItem.detail_id
					
					this.addParams.goodsId = goodsItem.detail_id
					this.addParams.goodsItem = goodsItem
					this.addParams.goodsItem.goodsName = goodsItem.service_name+"-"+goodsItem.service_objectName
					
					this.addParams.serviceId = serviceItem.virtualId
					this.addParams.serviceItem = serviceItem
					this.addParams.serviceItem.serviceName = serviceItem.title
					
					let arrList = ['62f62cb3fc7e0b47f73e28ad','62f62d40fc7e0b47f73e2949']
					if(arrList.indexOf(serviceItem.virtualId)>-1){
						this.saleManIdList = ['62ee0f7ac93f541cc51a306d,系统小花']
						this.addParams.saleManIdList = this.saleManIdList
					}
					
					this.$store.commit('xizaoka/set_addParams',this.addParams)
					this.$store.commit('xizaoka/set_money',goodsItem.total_price)
					this.$store.commit('xizaoka/set_activityMoney',goodsItem.total_price)
					
					this.getActivityList(this.goodsId)
				}else{
					this.goodsId = ''
					
					this.addParams.goodsId = ''
					this.addParams.goodsItem = {}
					this.goodsItem = {}
					
					this.addParams.serviceId = ''
					this.addParams.serviceItem = {}
					this.serviceItem = {}
					
					this.saleManIdList = []
					this.addParams.saleManIdList = this.saleManIdList
					
					this.$store.commit('xizaoka/set_addParams',this.addParams)
					this.$store.commit('xizaoka/set_money',0)
					this.$store.commit('xizaoka/set_activityMoney',0)
					
					this.getActivityList('');
				}
			},
			getServiceList(){
				let categoryId = ''
				if(this.typeId===1){
					categoryId='60210f916e6d952a3929f0ed'
				}else if(this.typeId===2){
					categoryId='60210f916e6d952a3929f0ee'
				}else if(this.typeId===3){
					categoryId='60210f916e6d952a3929f0ef'
				}
				let params = {
					"keyword": "",
					"applytype": '0,'+this.classType, // 应用分类 0:通用 1:猫 2:犬
					"categoryId": categoryId,  // 分类id，第三级
					"status": 1, // 虚拟卡状态 1启用；0未启用
					"weight": -1,  // 宠物体重
					"pageIndex": 1,
					"pageSize": 500
				}
				let loading = this.$loading()
				this.$http.post('/api/Product/VirtualCard/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.serviceList = res.data.data
					}
				})
			},
			// 活动
			changeActivityId(){
				this.addParams.activityId = this.activityId
				this.addParams.activityItem = this.$public.getMatchingItem(this.activityList,"_id",this.activityId)
				this.$store.commit('xizaoka/set_addParams',this.addParams)
				if(this.$public.isNull(this.addParams.activityId)){
					this.$store.commit('xizaoka/set_activityMoney',this.money)
				}else{
					let calcResult=this.$public.calcActivity(this.addParams.activityItem,this.money,1)
					this.$store.commit('xizaoka/set_activityMoney',calcResult.newPrice)
					if(!this.$public.isNull(calcResult.gift.give_list)){
						this.giveGoods = calcResult.gift;
						this.drawerGift_state = true;
					}
				}
			},
			getActivityList(goodsId){
				this.activityId = ''
				this.activityList = [];
				this.addParams.activityId = '';
				this.addParams.activityItem = {};
				this.$store.commit('jiyang/set_addParams',this.addParams)
				if(!goodsId){
					return ;
				}else{
					let goodsList = [{
						"goodsId": this.addParams.serviceId,
						"skus": this.addParams.goodsId,
						"skuValue": this.addParams.goodsItem.goodsName,
						"brand": '', // 品牌id 只有商品接收此字段
						"categoryId": this.addParams.serviceItem.category_info._id,  // 分类id
						unitId:''
					}]
					this.$util.getActivityOfProduct(this.userInfo,goodsList).then(res=>{
						this.activityList = res&&res[0].list;
					})
				}
			},
			// 销售人员
			changeSaleManIdList(){
				this.addParams.saleManIdList = this.saleManIdList
				this.$store.commit('xizaoka/set_addParams',this.addParams)
			},
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/BathStaffList', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
			isWeight(item){
				let w;
				if(!Number(this.weightRange)){
					w=10000000
				}else{
					w=Number(this.weightRange)
				}
				if(item.weight_detail&&item.weight_detail.enable_weight_limit===1){
					if(item.weight_detail.min_weight<=w&&w<item.weight_detail.max_weight){
						return true
					}else{
						return false
					}
				}else{
					return false
				}
			},
			isCanUse(item){
				let w;
				if(!Number(this.weightRange)){
					w=0
				}else{
					w=Number(this.weightRange)
				}
				if(item.weight_detail&&item.weight_detail.enable_weight_limit===1){
					if(w>item.weight_detail.max_weight){
						return false
					}else{
						return true
					}
				}else{
					return true
				}
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;
	padding-bottom: 60px;
	box-sizing: border-box;
	position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		height: 44px;
		padding:8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		position: absolute;
		z-index: 1;
	}
	.con{
		display: flex;padding:30px 0px 100px 0px;background-color: #fff;width:100%;height: 100%;box-sizing: border-box;padding-top:50px;position: absolute;top:0;
		.L{
			width:245px;border-right: 1px solid #f5f5f5;flex-shrink: 0;box-sizing: border-box;padding-left: 20px;
			.label{
				font-size: 14px;padding-bottom:10px;color:$fontColor;
			}
			.xmjBox{
				height: calc(100% - 220px);overflow-y: auto;
				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}
				.xmjItem{
					position: relative;width:206px;box-sizing: border-box;height: 52px;text-align: center;line-height: 52px;color:#666;font-size: 14px;background-color: #E8E8E8;border-radius: 2px;margin-top:15px;margin-left:0px;border:1px solid transparent;cursor: pointer;border-radius: 4px;
					&.active{
						background-color: $mainColor;color:#fff;
					}
					.checked{
						position: absolute;right:0;bottom:0;width:26px;height: 13px;text-align: center;color:#fff;
					}
				}
			}
		}
		.R{
			width:100%;height: 100%;overflow: auto;
			&::-webkit-scrollbar {
				width: 4px;
				// height: 4px;
			}
			.col{
				display: flex;
				align-items: center;
				padding-bottom:15px;
				.RLabel{
					font-size: 14px;
					color:#6E6E6E;
					text-align: right;
					line-height: 28px;
				}
			}
			.roomBox{
				display: flex;padding:10px 30px;flex-wrap: wrap;
				.room{
					position: relative;width:184px;height: 101px;border:1px solid #CDCDCD;box-sizing: border-box;background-color: #FFF;margin:6px 6px;text-align: center;cursor: pointer;border-radius: 4px;color:#999;overflow: hidden;
					.mask{
						position: absolute;top:-2px;left:-2px;z-index: 10;width:184px;height: 101px;background-color: rgba(0,0,0,.5);border-radius: 4px;
					}
					.tip{
						position: absolute;top:-1px;left:-1px;width:55px;height: 20px;text-align: center;color:#fff;background-color: $mainColor;font-size: 12px;line-height: 22px;z-index: 10;
					}
					.checked{
						position: absolute;right:-1px;bottom:-1px;width:40px;height: 18px;text-align: center;color:#fff;
					}
					.roomName{
						font-size: 16px;padding-top:23px;line-height: 20px;height: 40px;
					}
					.roomPrice{
						font-size: 14px;padding-top:0px;
					}
					&.active{
						border-color:$mainColor;color:$mainColor;
					}
				}
			}
		}
	}
}
</style>
